import styles from "./index.module.less";
import footerBg from "@/assets/imgs/mobile_footer_bg.png";
import filingIcon from "@/assets/imgs/filing-icon.png";
import iceRed from "@/assets/imgs/ice_red.svg";
import { Flex } from "antd";
import kefuQr from "@/assets/imgs/kefu_qr.png";
import gongzhonghaoQr from "@/assets/imgs/gongzhonghao_qr.png";
import classNames from "classnames";
import { useStore } from "@/stores";
import { useNavigate } from "react-router-dom";
import { isMobile } from "@/utils";

const MobileFooter = () => {
  const appStore = useStore("app");
  const navigate = useNavigate();
  return (
    <div className={styles.mobileFooter}>
      <img className={styles.footerBg} src={footerBg} />
      <div className={styles.footerContent}>
        <div className={styles.contactTitle}>xiaoice</div>
        <div className={styles.contactWrapper}>
          <div className={styles.contactContent}>
            <Flex justify="center" align="center" gap={".08rem"}>
              <img style={{ width: ".2rem" }} src={iceRed} />
              <div className={styles.allSpark}>小冰科技</div>
            </Flex>
            <div className={styles.contactInfo}>
              <div>商务合作：business@xiaoice.cn</div>
              <div>公司地址：北京市海淀区北四环西路67号</div>
              <div>联系电话：400-188-5609</div>
            </div>
            <Flex gap={".2rem"} align="center" justify="center">
              <Flex vertical gap={12} align="center">
                <img className={styles.qrcodeImg} src={kefuQr} />
                企业客服
              </Flex>
              <Flex vertical gap={12} align="center">
                <img className={styles.qrcodeImg} src={gongzhonghaoQr} />
                <span>微信公众号</span>
              </Flex>
            </Flex>
          </div>
        </div>
        <div id="footer" className={styles.copyRight}>
          ©{new Date().getFullYear()} 北京小冰跃动科技有限公司&nbsp;|&nbsp;
          <a href="https://beian.miit.gov.cn" target="_blank">
            京ICP备2025111115号-2
          </a>
          &nbsp;|&nbsp; 京ICP证 B2-20251025&nbsp;|&nbsp;
          <span className={styles.filingRecord}>
            <img src={filingIcon} alt="" />
            <a
              href="https://beian.mps.gov.cn/#/query/webSearch?code=11010802048088"
              rel="noreferrer"
              target="_blank"
            >
              京公网安备11010802048088号
            </a>
          </span>
        </div>
      </div>
    </div>
  );
};

export default MobileFooter;
